/* Penis size calculator (szc-). Data comes from #szc-blob (built by size-calculator/gen.py).
   Lengths are handled in inches inside; datasets in cm are converted. Percentile = share of men smaller. */
(function () {
  var root = document.getElementById('szc-app');
  var blob = document.getElementById('szc-blob');
  if (!root || !blob) return;
  var D = JSON.parse(blob.textContent);
  var CM = 2.54, R = D.corr;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  /* ---------- math ---------- */
  function erf(x) {
    var s = x < 0 ? -1 : 1; x = Math.abs(x);
    var t = 1 / (1 + 0.3275911 * x);
    var y = 1 - (((((1.061405429 * t - 1.453152027) * t) + 1.421413741) * t - 0.284496736) * t + 0.254829592) * t * Math.exp(-x * x);
    return s * y;
  }
  function Phi(z) { return 0.5 * (1 + erf(z / Math.SQRT2)); }
  function pdf(x, m, s) { var z = (x - m) / s; return Math.exp(-0.5 * z * z) / (s * Math.sqrt(2 * Math.PI)); }
  function empPct(t, x) {
    var q = t.q, n = q.length;
    if (x < q[0]) return Math.min(1, 100 * Phi((x - t.mean) / t.sd));
    if (x > q[n - 1]) return Math.max(99, 100 * Phi((x - t.mean) / t.sd));
    for (var i = 0; i < n - 1; i++) {
      if (x >= q[i] && x <= q[i + 1]) return (i + 1) + (q[i + 1] > q[i] ? (x - q[i]) / (q[i + 1] - q[i]) : 0);
    }
    return 50;
  }
  function setById(id) { for (var i = 0; i < D.sets.length; i++) if (D.sets[i].id === id) return D.sets[i]; return D.sets[0]; }
  function lenFor(set, L, m) {
    if (set.kind === 'emp') return { x: L, table: m === 'bp' ? 'bpel' : 'nbpel' };
    if (set.Lnbp) return { x: L, p: m === 'bp' ? set.L : set.Lnbp };
    if (set.adjust && m === 'nbp') return { x: L + D.gap, p: set.L, added: true };
    if (set.basis === 'nbp' && m === 'bp') return { x: L - D.gap, p: set.L, removed: true };
    return { x: L, p: set.L };
  }
  function pctLen(set, L, m) {
    var f = lenFor(set, L, m);
    if (f.table) return empPct(D.app[f.table], f.x);
    return 100 * Phi((f.x * CM - f.p[0]) / f.p[1]);
  }
  function gOf(set) { return set.G || setById('veale').G; }
  function pctGirth(set, G) {
    if (set.kind === 'emp') return empPct(D.app.girth, G);
    var g = gOf(set); return 100 * Phi((G * CM - g[0]) / g[1]);
  }
  function pctVolume(set, L, G, m) {
    if (set.kind === 'emp') { var La = m === 'nbp' ? L + D.gap : L; return empPct(D.app.volume_cuin, La * G * G / (4 * Math.PI)); }
    var f = lenFor(set, L, m), Lp = f.p, Lc = f.x * CM, Gc = G * CM, v = Lc * Gc * Gc / (4 * Math.PI);
    var mL = Lp[0], sL = Lp[1], mG = gOf(set)[0], sG = gOf(set)[1], sc = sL * Math.sqrt(1 - R * R);
    var a = Math.max(0.5, mG - 6 * sG), b = mG + 6 * sG, N = 360, h = (b - a) / N, tot = 0;
    for (var i = 0; i <= N; i++) {
      var g = a + i * h, w = (i === 0 || i === N) ? 0.5 : 1;
      var mc = mL + R * sL / sG * (g - mG);
      tot += w * pdf(g, mG, sG) * Phi((v * 4 * Math.PI / (g * g) - mc) / sc);
    }
    return Math.max(0, Math.min(100, 100 * tot * h));
  }

  /* ---------- state ---------- */
  var st = { u: 'in', L: 6.0, G: 5.0, m: 'bp', d: 'veale', example: true };
  (function init() {
    var p = new URLSearchParams(location.search);
    st.u = p.get('u') === 'cm' || (!p.get('u') && !/^en/i.test(navigator.language || 'en')) ? 'cm' : 'in';
    var num = function (k) { var v = parseFloat(p.get(k)); return isFinite(v) && v > 0 ? v : null; };
    var k = st.u === 'cm' ? 1 / CM : 1;
    if (num('l')) { st.L = num('l') * k; st.example = false; }
    if (num('g')) { st.G = num('g') * k; st.example = false; }
    if (p.get('m') === 'nbp') st.m = 'nbp';
    if (p.get('d')) st.d = setById(p.get('d')).id;
  })();

  var fmt = function (inches, dp) { var v = st.u === 'cm' ? inches * CM : inches; return v.toFixed(dp == null ? 1 : dp); };
  var unit = function () { return st.u === 'cm' ? 'cm' : 'in'; };
  var round = function (p) { return p < 1 ? '<1' : p > 99 ? '99+' : String(Math.round(p)); };
  function band(p, word) {
    if (p < 2.5) return 'Very small';
    if (p < 10) return 'Small';
    if (p < 25) return 'Below average';
    if (p <= 75) return 'Average';
    if (p <= 90) return 'Above average';
    if (p <= 97.5) return word === 'g' ? 'Thick' : 'Large';
    return word === 'g' ? 'Very thick' : 'Very large';
  }
  function oneIn(p) {
    var r = 100 / Math.max(0.0001, 100 - p);
    if (r < 2) return '';
    if (r >= 10000) return 'Fewer than 1 in 10,000 men is this long.';
    var n = r < 100 ? Math.round(r) : r < 1000 ? Math.round(r / 10) * 10 : Math.round(r / 100) * 100;
    return 'Only about 1 in ' + Number(n).toLocaleString('en-US') + ' men is this long.';
  }

  /* ---------- inputs ---------- */
  var RANGE = { L: [2, 11], G: [2, 8] };
  function syncInputs() {
    ['L', 'G'].forEach(function (k) { var n = $('[data-num="' + k + '"]'); if (n && document.activeElement !== n) n.value = fmt(st[k]); });
    $$('[data-unit-lbl]').forEach(function (el) { el.textContent = unit(); });
    $$('[data-u]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.u === st.u)); });
    $$('[data-m]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.m === st.m)); });
    var sel = $('#szc-d'); if (sel) sel.value = st.d;
  }
  function readNum(k, raw) {
    var v = parseFloat(String(raw).replace(',', '.'));
    if (!isFinite(v) || v <= 0) return false;
    var inches = st.u === 'cm' ? v / CM : v;
    st[k] = Math.min(RANGE[k][1], Math.max(RANGE[k][0], inches));
    return true;
  }
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.dataset.num && readNum(t.dataset.num, t.value)) { st.example = false; render(); }
  });
  root.addEventListener('change', function (e) {
    if (e.target.id === 'szc-d') { st.d = e.target.value; render(); }
  });
  root.addEventListener('blur', function (e) { if (e.target.dataset && e.target.dataset.num) e.target.value = fmt(st[e.target.dataset.num]); }, true);
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
    if (b.dataset.u) { st.u = b.dataset.u; syncInputs(); render(); }
    else if (b.dataset.m) { st.m = b.dataset.m; st.example = false; syncInputs(); render(); }
    else if (b.dataset.tab) { tab(b.dataset.tab); }
    else if (b.hasAttribute('data-share')) share(b.dataset.share, b);
  });

  /* ---------- pop-ups (stay on the calculator) ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-pop]');
    if (o) { var d = document.getElementById('szc-pop-' + o.dataset.pop); if (d) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); } return; }
    var c = e.target.closest('[data-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) { if (dd.close) dd.close(); else dd.removeAttribute('open'); } return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('szc-pop') && e.target.close) e.target.close();
  });

  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-yt]'); if (!v) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + v.dataset.yt + '?autoplay=1&rel=0';
    f.title = v.getAttribute('aria-label') || 'Video'; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
    f.className = 'szc-vid__frame'; v.replaceWith(f);
  });

  /* ---------- results ---------- */
  var last = {};
  function render() {
    var set = setById(st.d);
    var pl = pctLen(set, st.L, st.m), pg = pctGirth(set, st.G), pv = pctVolume(set, st.L, st.G, st.m);
    last = { set: set, pl: pl, pg: pg, pv: pv };
    $('[data-out="example"]').hidden = !st.example;
    $('[data-out="lenPct"]').textContent = round(pl) + '%';
    $('[data-out="lenHead"]').textContent = 'Longer than ' + round(pl) + ' out of 100 ' + set.room;
    $('[data-out="lenBand"]').textContent = band(pl, 'l');
    $('[data-out="girPct"]').textContent = round(pg) + '%';
    $('[data-out="girHead"]').textContent = 'Thicker than ' + round(pg) + ' out of 100 ' + set.room;
    $('[data-out="girBand"]').textContent = band(pg, 'g');
    $('[data-out="volHead"]').textContent = 'Bigger overall than ' + round(pv) + ' out of 100 ' + set.room;
    $('[data-out="volBand"]').textContent = band(pv, 'v');
    var lf = lenFor(set, st.L, st.m), note = $('[data-out="lenNote"]');
    note.hidden = !(lf.added || lf.removed);
    note.textContent = lf.added ? 'We added ' + fmt(D.gap, 1) + ' ' + unit() + ' because you did not press to the bone.' : lf.removed ? 'This study did not press to the bone, so we took ' + fmt(D.gap, 1) + ' ' + unit() + ' off your length.' : '';
    var gn = $('[data-out="girNote"]'); gn.hidden = !!(set.G || set.kind === 'emp'); gn.textContent = gn.hidden ? '' : 'No girth data for this group, so girth is compared with men worldwide.';
    var allEl = document.querySelector('[data-out="all"]');
    if (allEl) allEl.innerHTML = D.sets.filter(function (s) { return s.group !== 'country' || s.id === st.d; }).map(function (s) {
      return '<tr' + (s.id === st.d ? ' class="is-on"' : '') + '><th scope="row">' + s.name + '</th><td>' + round(pctLen(s, st.L, st.m)) + '%</td><td>' + round(pctGirth(s, st.G)) + '%</td></tr>';
    }).join('');
    mini('L'); mini('G'); drawMap(); drawCmp(); saveUrl();
  }
  function saveUrl() {
    if (st.example) return;
    var p = new URLSearchParams(location.search), f = st.u === 'cm' ? CM : 1;
    p.set('l', (st.L * f).toFixed(1)); p.set('g', (st.G * f).toFixed(1)); p.set('u', st.u); p.set('m', st.m); p.set('d', st.d);
    try { history.replaceState(null, '', location.pathname + '?' + p.toString() + location.hash); } catch (e) {}
  }

  /* ---------- small bell curve in each result card ---------- */
  function mini(which, svgArg, Wa, Ha) {
    var svg = svgArg || $('[data-out="curve' + which + '"]'); if (!svg) return;
    var set = last.set, W = Wa || Math.max(140, Math.min(560, (svg.parentNode.clientWidth || 300) - 2)), H = Ha || Math.round(Math.max(74, Math.min(150, W * (window.innerWidth > 1000 ? 0.42 : 0.3)))), B = 16;
    var lo = which === 'L' ? 3 : 2.8, hi = which === 'L' ? 9.5 : 7.2, N = 120, pts = [], ymax = 0;
    var app = set.kind === 'emp' ? D.app[which === 'L' ? (st.m === 'bp' ? 'bpel' : 'nbpel') : 'girth'] : null;
    for (var i = 0; i <= N; i++) {
      var x = lo + (hi - lo) * i / N, y = 0;
      if (app) { for (var j = 0; j < app.q.length; j++) y += pdf(x, app.q[j], 0.22); y /= app.q.length; }
      else { var p = which === 'L' ? lenFor(set, 1, st.m).p : gOf(set), sh = which === 'L' && set.adjust && st.m === 'nbp' ? D.gap : 0; y = pdf(x + sh, p[0] / CM, p[1] / CM); }
      pts.push([x, y]); ymax = Math.max(ymax, y);
    }
    var X = function (x) { return 4 + (x - lo) / (hi - lo) * (W - 8); }, Y = function (y) { return H - B - y / ymax * (H - B - 8); };
    var you = which === 'L' ? st.L : st.G, yx = X(Math.max(lo, Math.min(hi, you)));
    var line = pts.map(function (q, i) { return (i ? 'L' : 'M') + X(q[0]).toFixed(1) + ' ' + Y(q[1]).toFixed(1); }).join('');
    var f = pts.filter(function (q) { return q[0] <= you; });
    var area = f.length ? 'M' + X(lo) + ' ' + Y(0) + f.map(function (q) { return 'L' + X(q[0]).toFixed(1) + ' ' + Y(q[1]).toFixed(1); }).join('') + 'L' + yx.toFixed(1) + ' ' + Y(0) + 'Z' : '';
    var ticks = '', a = st.u === 'cm' ? Math.ceil(lo * CM / 4) * 4 : Math.ceil(lo), step = st.u === 'cm' ? 4 : 1, b = st.u === 'cm' ? hi * CM : hi;
    for (var t = a; t <= b; t += step) { var xi = st.u === 'cm' ? t / CM : t; ticks += '<text x="' + X(xi).toFixed(1) + '" y="' + (H - 2) + '" class="szc-tk">' + t + '</text>'; }
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.innerHTML = '<path d="' + area + '" class="szc-area"/><path d="' + line + '" class="szc-line"/><line x1="4" x2="' + (W - 4) + '" y1="' + (H - B) + '" y2="' + (H - B) + '" class="szc-ax"/>' + ticks +
      '<line x1="' + yx.toFixed(1) + '" x2="' + yx.toFixed(1) + '" y1="4" y2="' + (H - B) + '" class="szc-you"/><circle cx="' + yx.toFixed(1) + '" cy="5" r="4" fill="#1A1A1A"/>';
  }

  /* ---------- extra views (closed until asked for) ---------- */
  function tab(id) {
    var btn = $('[data-tab="' + id + '"]'), open = btn.getAttribute('aria-expanded') !== 'true';
    $$('[data-tab]').forEach(function (b) { b.setAttribute('aria-expanded', String(open && b.dataset.tab === id)); });
    $$('[data-panel]').forEach(function (p) { p.hidden = !(open && p.dataset.panel === id); });
  }
  var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { mini('L'); mini('G'); drawMap(); drawCmp(); }, 150); });

  function drawMap(svgArg, Wa) {
    var svg = svgArg || $('[data-out="map"]'); if (!svg || (!svgArg && svg.closest('[hidden]'))) return;
    var W = Wa || Math.max(260, Math.min(680, (svg.parentNode.clientWidth || 360) - 2)), H = Math.round(Math.max(220, Math.min(320, W * 0.7))), L0 = 40, B = 36, T = 8, Rr = 8;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var lx = [4, 9.25], gy = [3.5, 6.75], s0 = last.set || D.sets[0];
    if (s0.kind !== 'emp') {
      var lp0 = lenFor(s0, 1, st.m).p, gp0 = gOf(s0);
      lx = [Math.min(4, Math.floor((lp0[0] / CM - 2.6 * lp0[1] / CM) * 2) / 2), Math.max(8.5, Math.ceil((lp0[0] / CM + 2.6 * lp0[1] / CM) * 2) / 2)];
      gy = [Math.min(3.5, Math.floor((gp0[0] / CM - 2.6 * gp0[1] / CM) * 2) / 2), Math.max(6.5, Math.ceil((gp0[0] / CM + 2.6 * gp0[1] / CM) * 2) / 2)];
    }
    var X = function (x) { return L0 + (x - lx[0]) / (lx[1] - lx[0]) * (W - L0 - Rr); };
    var Y = function (y) { return H - B - (y - gy[0]) / (gy[1] - gy[0]) * (H - B - T); };
    var set = last.set || D.sets[0], grid;
    if (set.kind === 'emp') grid = D.app.grid;
    else {
      var lp = lenFor(set, 1, st.m).p, gp = gOf(set), mL = lp[0] / CM, sL = lp[1] / CM, mG = gp[0] / CM, sG = gp[1] / CM;
      grid = [];
      for (var gx = lx[0]; gx < lx[1] - 1e-9; gx += 0.25) for (var gy2 = gy[0]; gy2 < gy[1] - 1e-9; gy2 += 0.25) {
        var zx = (gx + 0.125 - mL) / sL, zy = (gy2 + 0.125 - mG) / sG;
        grid.push([gx, gy2, Math.exp(-0.5 * (zx * zx - 2 * R * zx * zy + zy * zy) / (1 - R * R))]);
      }
      var top = 0; grid.forEach(function (c) { top = Math.max(top, c[2]); });
      grid = grid.filter(function (c) { return c[2] > top * 0.02; });
    }
    var mx = 0; grid.forEach(function (c) { mx = Math.max(mx, c[2]); });
    var cells = grid.filter(function (c) { return c[0] >= lx[0] && c[0] < lx[1] && c[1] >= gy[0] && c[1] < gy[1]; }).map(function (c) {
      var o = Math.pow(c[2] / mx, 0.6);
      return '<rect x="' + X(c[0]).toFixed(1) + '" y="' + Y(c[1] + 0.25).toFixed(1) + '" width="' + (X(c[0] + 0.25) - X(c[0]) - 1).toFixed(1) + '" height="' + (Y(c[1]) - Y(c[1] + 0.25) - 1).toFixed(1) + '" rx="2" fill="rgba(59,76,140,' + (0.08 + 0.85 * o).toFixed(3) + ')"/>';
    }).join('');
    var ax = '';
    for (var x = Math.ceil(lx[0]); x <= lx[1]; x++) ax += '<text x="' + X(x) + '" y="' + (H - 16) + '" class="szc-tk">' + (st.u === 'cm' ? (x * CM).toFixed(0) : x) + '</text>';
    for (var y = Math.ceil(gy[0] * 2) / 2; y <= gy[1]; y += 0.5) ax += '<text x="' + (L0 - 8) + '" y="' + (Y(y) + 4) + '" class="szc-tk" text-anchor="end">' + (st.u === 'cm' ? (y * CM).toFixed(1) : y) + '</text>';
    ax += '<text x="' + ((L0 + W) / 2) + '" y="' + (H - 2) + '" class="szc-axl">Length (' + unit() + ')</text>';
    ax += '<text transform="translate(12 ' + ((H - B) / 2) + ') rotate(-90)" class="szc-axl">Girth (' + unit() + ')</text>';
    var Lb = set.kind === 'emp' ? (st.m === 'nbp' ? st.L + D.gap : st.L) : lenFor(set, st.L, st.m).x;
    var dx = X(Math.max(lx[0], Math.min(lx[1] - 0.05, Lb))), dy = Y(Math.max(gy[0] + 0.05, Math.min(gy[1], st.G)));
    svg.innerHTML = cells + ax + '<circle cx="' + dx + '" cy="' + dy + '" r="11" class="szc-dot"/><circle cx="' + dx + '" cy="' + dy + '" r="4" fill="#1A1A1A"/>' +
      '<text x="' + Math.min(W - 40, dx + 16) + '" y="' + (dy - 10) + '" class="szc-dotlbl">You</text>';
  }

  /* outline shape: s = along the length (0 at the body), t = across */
  function outline(s0, t, Lin, Gin, pxmm, vert) {
    var len = Lin * 25.4 * pxmm, Dd = Gin / Math.PI * 25.4 * pxmm, r = Dd / 2;
    var hrx = Dd * 0.42, hry = r * 1.07, cs = s0 + len - hrx, ds = hrx * Math.sqrt(Math.max(0, 1 - Math.pow(r / hry, 2)));
    var rb = Math.min(r * 0.25, 8);
    var P = function (s, tt) { return vert ? (tt.toFixed(1) + ' ' + s.toFixed(1)) : (s.toFixed(1) + ' ' + tt.toFixed(1)); };
    var arc = vert ? ('A' + hry.toFixed(1) + ' ' + hrx.toFixed(1) + ' 0 1 0 ') : ('A' + hrx.toFixed(1) + ' ' + hry.toFixed(1) + ' 0 1 1 ');
    return 'M' + P(s0, t - r + rb) + 'Q' + P(s0, t - r) + ' ' + P(s0 + rb, t - r) + 'L' + P(cs - ds, t - r) + arc + P(cs - ds, t + r) +
      'L' + P(s0 + rb, t + r) + 'Q' + P(s0, t + r) + ' ' + P(s0, t + r - rb) + 'Z';
  }
  var cmpOn = {}, cmpOrder = [], MAXC = 3;
  D.cmp.forEach(function (c) { cmpOn[c.k] = !!c.on; if (c.on) cmpOrder.push(c.k); });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cmpk]'); if (!b) return;
    var k = b.dataset.cmpk;
    if (cmpOn[k]) { cmpOn[k] = false; cmpOrder = cmpOrder.filter(function (x) { return x !== k; }); }
    else { cmpOn[k] = true; cmpOrder.push(k); if (cmpOrder.length > MAXC) cmpOn[cmpOrder.shift()] = false; }
    $$('[data-cmpk]').forEach(function (x) { x.setAttribute('aria-pressed', String(!!cmpOn[x.dataset.cmpk])); });
    drawCmp();
  });
  function drawCmp(svgArg, Wa) {
    var svg = svgArg || $('[data-out="cmp"]'); if (!svg) return;
    var Lb = st.m === 'nbp' ? st.L + D.gap : st.L;
    var on = D.cmp.filter(function (c) { return cmpOn[c.k]; });
    var shapes = on.filter(function (c) { return c.G; }), marks = on.filter(function (c) { return !c.G; });
    var maxL = Math.max.apply(null, [Lb].concat(on.map(function (c) { return c.L; })));
    var maxG = Math.max.apply(null, [st.G].concat(shapes.map(function (c) { return c.G; })));
    var avail = Wa || Math.max(280, (svg.parentNode.clientWidth || 600) - 4), s0 = 10;
    var perIn = Math.min(Wa ? 150 : 110, (avail - s0 - 40) / maxL), pxmm = perIn / 25.4;
    var top = marks.length ? 22 * marks.length + 8 : 8, half = maxG / Math.PI * perIn / 2 * 1.08, t = top + half;
    var W = avail, out = '';
    out += '<line x1="' + s0 + '" x2="' + s0 + '" y1="' + (t - half - 6) + '" y2="' + (t + half + 6) + '" class="szc-wall"/>';
    out += '<path d="' + outline(s0, t, Lb, st.G, pxmm, false) + '" class="szc-c-you"/>';
    shapes.slice().sort(function (a, b) { return b.L - a.L; }).forEach(function (c) { out += '<path d="' + outline(s0, t, c.L, c.G, pxmm, false) + '" class="szc-c-' + c.k + '"/>'; });
    marks.forEach(function (c, i) {
      var x2 = s0 + c.L * perIn, yy = 14 + i * 22;
      out += '<line x1="' + s0 + '" x2="' + x2.toFixed(1) + '" y1="' + yy + '" y2="' + yy + '" class="szc-c-' + c.k + '"/><line x1="' + x2.toFixed(1) + '" x2="' + x2.toFixed(1) + '" y1="' + (yy - 6) + '" y2="' + (yy + 6) + '" class="szc-c-' + c.k + '"/>' +
        '<text x="' + (x2 - 6).toFixed(1) + '" y="' + (yy - 5) + '" class="szc-cs" text-anchor="end">' + fmt(c.L) + ' ' + unit() + '</text>';
    });
    var y = t + half + 10, ticks = '', step = st.u === 'cm' ? 5 / CM : 1;
    for (var v = 0; v <= maxL + 0.001; v += step) {
      var xx = s0 + v * perIn;
      ticks += '<line x1="' + xx.toFixed(1) + '" x2="' + xx.toFixed(1) + '" y1="' + y + '" y2="' + (y + 6) + '" class="szc-ax"/><text x="' + xx.toFixed(1) + '" y="' + (y + 20) + '" class="szc-tk">' + (st.u === 'cm' ? Math.round(v * CM) : Math.round(v)) + '</text>';
    }
    var H = y + 28;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H); svg.setAttribute('width', W); svg.setAttribute('height', H);
    svg.innerHTML = out + '<line x1="' + s0 + '" x2="' + (s0 + maxL * perIn).toFixed(1) + '" y1="' + y + '" y2="' + y + '" class="szc-ax"/>' + ticks;
    if (svgArg) return;
    var sz = function (L, G) { return fmt(L) + ' × ' + fmt(G) + ' ' + unit(); };
    var ys = $('[data-cmps="you"]'); if (ys) ys.setAttribute('data-tip', sz(Lb, st.G));
    D.cmp.forEach(function (c) { var e = $('[data-cmps="' + c.k + '"]'); if (e) e.setAttribute('data-tip', sz(c.L, c.G)); });
  }

  /* ---------- share ---------- */
  function shareUrl() { saveUrl(); return location.origin + location.pathname + location.search; }
  function sizeStr() { return fmt(st.L) + ' × ' + fmt(st.G) + ' ' + unit() + (st.m === 'bp' ? ', pressed to the bone' : ', not pressed'); }
  function ord(p) {
    if (p < 1) return 'bottom 1%';
    if (p > 99) return 'top 1%';
    var n = Math.round(p), s = (n % 100 >= 11 && n % 100 <= 13) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
    return n + s + ' percentile';
  }
  function shareText() {
    var set = last.set, home = set.kind === 'emp' || set.id === 'tr' || set.id === 'us';
    var other = setById(home ? 'veale' : 'app');
    var ol = pctLen(other, st.L, st.m), og = pctGirth(other, st.G);
    var r = 100 / Math.max(0.0001, 100 - last.pl), rare = r >= 2 && r < 10000 ? ' (about 1 in ' + Math.round(r).toLocaleString('en-US') + ')' : '';
    var lines = [
      'My stats: ' + fmt(st.L) + ' × ' + fmt(st.G) + ' ' + unit() + ', ' + (st.m === 'bp' ? 'bone-pressed' : 'not bone-pressed'),
      '',
      'Vs ' + set.room + ':',
      'Length: ' + ord(last.pl) + rare,
      'Girth: ' + ord(last.pg),
      'Overall: ' + ord(last.pv),
      '',
      'Same size vs ' + (home ? 'men measured by doctors' : 'guys who measured at home') + ': ' + ord(ol).replace(' percentile', '') + ' percentile length, ' + ord(og).replace(' percentile', '') + ' girth. Funny how much "average" depends on who\'s holding the ruler.',
      '',
      'Calculator: ' + location.origin + location.pathname
    ];
    return lines.join('\n');
  }
  function flash(b, t) { var o = b.textContent; b.textContent = t; setTimeout(function () { b.textContent = o; }, 1600); }
  function copyOld(t) {
    var a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.position = 'fixed'; a.style.opacity = '0';
    document.body.appendChild(a); a.select(); var ok = false; try { ok = document.execCommand('copy'); } catch (e) {} a.remove(); return ok;
  }
  function copy(t, b) {
    var done = function () { flash(b, 'Copied'); }, fail = function () { flash(b, copyOld(t) ? 'Copied' : 'Copy failed'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(done, fail); else fail();
  }
  function share(kind, b) {
    if (kind === 'link') copy(shareUrl(), b);
    else if (kind === 'text') copy(shareText(), b);
    else if (kind === 'img') card(b);
  }
  function card(b) {
    var o = b.textContent; b.textContent = 'Making image';
    makeCard().then(function (c) {
      c.toBlob(function (bl) {
        b.textContent = o;
        if (!bl) return;
        var f = new File([bl], 'my-size.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [f] })) { navigator.share({ files: [f] }).catch(function () {}); return; }
        var a = document.createElement('a'); a.href = URL.createObjectURL(bl); a.download = 'my-size.png'; document.body.appendChild(a); a.click(); a.remove();
        flash(b, 'Saved');
      }, 'image/png');
    }).catch(function () { b.textContent = o; });
  }
  /* SVG styles copied into each chart so it renders the same inside the image */
  var SVGCSS = 'text{font-family:Inter,Arial,sans-serif}.szc-ax{stroke:#b9bfcc;stroke-width:1}.szc-tk{font:600 11.5px Inter,Arial,sans-serif;fill:#6f7080;text-anchor:middle}' +
    '.szc-axl{font:600 11.5px Inter,Arial,sans-serif;fill:#424141;text-anchor:middle}.szc-line{fill:none;stroke:#3B4C8C;stroke-width:2.5}.szc-area{fill:rgba(59,76,140,.16)}' +
    '.szc-you{stroke:#1A1A1A;stroke-width:2;stroke-dasharray:4 3}.szc-dot{fill:#F9C42E;stroke:#1A1A1A;stroke-width:2}' +
    '.szc-dotlbl{font:800 13px Inter,Arial,sans-serif;fill:#1A1A1A;paint-order:stroke;stroke:#fff;stroke-width:4px;stroke-linejoin:round}' +
    '.szc-c-you{fill:rgba(205,213,236,.9);stroke:#3B4C8C;stroke-width:2}.szc-c-avg{fill:none;stroke:#1A1A1A;stroke-width:2;stroke-dasharray:7 5}' +
    '.szc-c-trained{fill:none;stroke:#d9a514;stroke-width:2.5}.szc-c-start{fill:none;stroke:#7c8499;stroke-width:2;stroke-dasharray:2 4;stroke-linecap:round}' +
    '.szc-c-lt{fill:none;stroke:#16a34a;stroke-width:2;stroke-dasharray:6 4}.szc-c-ons{fill:none;stroke:#E5484D;stroke-width:2;stroke-dasharray:6 4}' +
    '.szc-cs{font:600 12px Inter,Arial,sans-serif;fill:#424141}.szc-wall{stroke:#9aa3b8;stroke-width:3;stroke-linecap:round}';
  function svgImg(svg) {
    return new Promise(function (res, rej) {
      var vb = (svg.getAttribute('viewBox') || '0 0 300 150').split(/\s+/).map(Number);
      var c = svg.cloneNode(true);
      c.setAttribute('xmlns', 'http://www.w3.org/2000/svg'); c.setAttribute('width', vb[2]); c.setAttribute('height', vb[3]);
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'style'); s.textContent = SVGCSS; c.insertBefore(s, c.firstChild);
      var im = new Image(); im.onload = function () { res({ img: im, w: vb[2], h: vb[3] }); }; im.onerror = rej;
      im.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(c));
    });
  }
  function loadImg(src) {
    return new Promise(function (res) { if (!src) return res(null); var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = src; });
  }
  function makeCard() {
    var fonts = document.fonts && document.fonts.load ? Promise.all([document.fonts.load('700 100px "Barlow Condensed"'), document.fonts.load('600 20px Inter'), document.fonts.load('500 20px Inter')]).catch(function () {}) : Promise.resolve();
    var NS = 'http://www.w3.org/2000/svg', mk = function () { return document.createElementNS(NS, 'svg'); };
    var tL = mk(), tG = mk(), tM = mk(), tC = mk();
    mini('L', tL, 330, 128); mini('G', tG, 330, 128); drawMap(tM, 330); drawCmp(tC, 1040);
    var svgs = [tL, tG, tM, tC].map(svgImg);
    return Promise.all([fonts, loadImg(root.getAttribute('data-logo'))].concat(svgs)).then(function (r) {
      var logo = r[1], sL = r[2], sG = r[3], sM = r[4], sC = r[5];
      var W = 1200, P = 48, GAP = 20, BAR = 'Barlow Condensed", "Arial Narrow", Arial, sans-serif', INT = 'Inter, Arial, sans-serif';
      var c = document.createElement('canvas'), H = 1440; c.width = W; c.height = H;
      var x = c.getContext('2d');
      var rr = function (X, Y, w, h, r, fill, stroke) { x.beginPath(); if (x.roundRect) x.roundRect(X, Y, w, h, r); else x.rect(X, Y, w, h); if (fill) { x.fillStyle = fill; x.fill(); } if (stroke) { x.strokeStyle = stroke; x.lineWidth = 1.5; x.stroke(); } };
      var txt = function (t, X, Y, font, color, align) { x.font = font; x.fillStyle = color; x.textAlign = align || 'left'; x.fillText(t, X, Y); x.textAlign = 'left'; };
      var wrap = function (t, X, Y, maxW, lh, font, color, maxLines) {
        x.font = font; x.fillStyle = color; var words = t.split(' '), line = '', n = 0;
        for (var i = 0; i < words.length; i++) { var test = line ? line + ' ' + words[i] : words[i]; if (x.measureText(test).width > maxW && line) { x.fillText(line, X, Y + n * lh); n++; line = words[i]; if (n >= (maxLines || 9)) return; } else line = test; }
        if (line) x.fillText(line, X, Y + n * lh);
      };
      var pill = function (t, rightX, Y) { x.font = '700 15px ' + INT; var w = x.measureText(t.toUpperCase()).width + 24; rr(rightX - w, Y - 22, w, 32, 16, '#eef0f6'); txt(t.toUpperCase(), rightX - w / 2, Y, '700 15px ' + INT, '#3B4C8C', 'center'); };
      var fit = function (s, X, Y, w, h, mid) { var k = Math.min(w / s.w, h / s.h), dw = s.w * k, dh = s.h * k; x.drawImage(s.img, X + (w - dw) / 2, Y + (mid ? (h - dh) / 2 : h - dh), dw, dh); };
      x.fillStyle = '#f4f6fa'; x.fillRect(0, 0, W, H);
      x.fillStyle = '#3B4C8C'; x.fillRect(0, 0, W, 10);
      txt('PENIS SIZE CALCULATOR', P, 66, '700 20px ' + INT, '#3B4C8C');
      txt((fmt(st.L) + ' × ' + fmt(st.G) + ' ' + unit() + (st.m === 'bp' ? ', pressed to the bone' : ', not pressed')).toUpperCase(), P, 118, '700 46px "' + BAR, '#1A1A1A');
      txt('Compared with ' + last.set.room, P, 158, '500 26px ' + INT, '#424141');
      var y0 = 190, ch = 470, cw = (W - 2 * P - 2 * GAP) / 3;
      [[last.pl, 'Length', 'Longer than ' + round(last.pl) + ' out of 100 ' + last.set.room, band(last.pl, 'l'), sL],
       [last.pg, 'Girth', 'Thicker than ' + round(last.pg) + ' out of 100 ' + last.set.room, band(last.pg, 'g'), sG]].forEach(function (k, i) {
        var X = P + i * (cw + GAP);
        rr(X, y0, cw, ch, 24, '#ffffff', '#e7e4df');
        txt(k[1].toUpperCase(), X + 24, y0 + 46, '700 18px ' + INT, '#3B4C8C');
        pill(k[3], X + cw - 20, y0 + 46);
        txt(round(k[0]) + '%', X + 20, y0 + 178, '700 128px "' + BAR, '#1A1A1A');
        wrap(k[2], X + 24, y0 + 222, cw - 48, 29, '600 21px ' + INT, '#1A1A1A', 3);
        fit(k[4], X + 16, y0 + ch - 150, cw - 32, 132);
      });
      var XM = P + 2 * (cw + GAP);
      rr(XM, y0, cw, ch, 24, '#ffffff', '#e7e4df');
      txt('LENGTH VS GIRTH', XM + 24, y0 + 46, '700 18px ' + INT, '#3B4C8C');
      x.font = '700 18px ' + INT; var lw1 = x.measureText('LENGTH VS GIRTH').width;
      x.font = '700 15px ' + INT; var pw1 = x.measureText(band(last.pv, 'v').toUpperCase()).width + 24;
      var low = 24 + lw1 + 16 + pw1 + 20 > cw, ty = low ? 40 : 0;
      if (low) { x.font = '700 15px ' + INT; pill(band(last.pv, 'v'), XM + 24 + pw1, y0 + 84); } else pill(band(last.pv, 'v'), XM + cw - 20, y0 + 46);
      wrap('Bigger overall than ' + round(last.pv) + ' out of 100 ' + last.set.room, XM + 24, y0 + 88 + ty, cw - 48, 29, '600 21px ' + INT, '#1A1A1A', 3);
      fit(sM, XM + 10, y0 + 170, cw - 20, ch - 186);
      var y1 = y0 + ch + GAP, hc = 430;
      rr(P, y1, W - 2 * P, hc, 24, '#ffffff', '#e7e4df');
      var Lb = st.m === 'nbp' ? st.L + D.gap : st.L;
      var items = [{ k: 'you', label: 'You', L: Lb, G: st.G }].concat(D.cmp.filter(function (q) { return cmpOn[q.k]; }));
      var lx = P + 28, ly = y1 + 48;
      items.forEach(function (q) {
        var lab = q.label + '  ' + fmt(q.L) + ' × ' + fmt(q.G) + ' ' + unit();
        x.font = '600 19px ' + INT; var w = x.measureText(lab).width;
        if (lx + w + 60 > W - P - 20) { lx = P + 28; ly += 36; }
        sw(q.k, lx, ly - 14);
        txt(q.label, lx + 42, ly, '700 19px ' + INT, '#1A1A1A');
        x.font = '700 19px ' + INT; var w1 = x.measureText(q.label).width;
        txt(fmt(q.L) + ' × ' + fmt(q.G) + ' ' + unit(), lx + 50 + w1, ly, '500 19px ' + INT, '#6f7080');
        lx += 42 + w + 36;
      });
      fit(sC, P + 24, ly + 22, W - 2 * P - 48, y1 + hc - ly - 40, true);
      function sw(k, X, Y) {
        var st2 = { you: ['rgba(205,213,236,.9)', '#3B4C8C', []], avg: [null, '#1A1A1A', [6, 4]], trained: [null, '#d9a514', []], start: [null, '#7c8499', [2, 4]], lt: [null, '#16a34a', [6, 4]], ons: [null, '#E5484D', [6, 4]] }[k] || [null, '#999', []];
        x.save(); x.setLineDash(st2[2]); x.lineWidth = 2.5; rr(X, Y, 32, 16, 8, st2[0], st2[1]); x.restore();
      }
      var y2 = y1 + hc + 64;
      txt(('You are bigger than ' + round(last.pv) + ' out of 100').toUpperCase(), P, y2 + 20, '700 62px "' + BAR, '#1A1A1A');
      txt(last.set.room + ', length and girth together', P, y2 + 64, '500 26px ' + INT, '#424141');
      var fy = H - 64;
      x.fillStyle = '#e7e4df'; x.fillRect(P, fy - 62, W - 2 * P, 1.5);
      if (logo) { var lh = 54, lw = logo.width / logo.height * lh; x.drawImage(logo, P, fy - lh + 14, lw, lh); }
      else txt('EPIC EXTENDER', P, fy, '700 40px "' + BAR, '#1A1A1A');
      txt('epicextender.com/pages/penis-size-calculator', W - P, fy, '600 22px ' + INT, '#3B4C8C', 'right');
      return c;
    });
  }
  if (/[?&]szcdebug=1/.test(location.search)) window.szcDebug = { card: function () { return makeCard().then(function (c) { return c.toDataURL('image/jpeg', 0.85); }); }, text: function () { return shareText(); } };

  syncInputs();
  render();
  root.classList.add('is-ready');
})();
